import { SupplierData, ManufacturerData } from '@/types/organisation'

export const digikeySampleData: SupplierData = {
  name: "Digi-Key Electronics",
  logo: "/truck-icon.svg",  // TODO: change to LucideIcon 
  type: "Authorized Distributor",
  headquarters: "Thief River Falls, Minnesota, USA",
  regionsServed: ["Global"],
  website: "https://www.digikey.com",
  primaryContact: {
    name: "John Doe",
    email: "john.doe@digikey.com",
    phone: "+1 (800) 344-4539"
  },
  customerSupport: {
    phone: "+1 (800) 344-4539",
    email: "customer.service@digikey.com",
    chat: "https://www.digikey.com/en/help/contact-us"
  },
  address: "701 Brooks Ave S, Thief River Falls, MN 56701, USA",
  operatingHours: "24/7 online, phone support varies by region",
  productsOffered: [
    "Integrated Circuits (ICs)",
    "Discrete Semiconductors",
    "Passive Components",
    "Electromechanical",
    "Connectors",
    "Sensors"
  ],
  brandsSupported: [
    "Texas Instruments",
    "Analog Devices",
    "Microchip",
    "TE Connectivity",
    "Vishay"
  ],
  availability: "Most items ship same day",
  pricing: "Tiered pricing available, bulk discounts",
  shipping: {
    regions: ["North America", "Europe", "Asia", "Oceania"],
    leadTime: "Same day - 2 business days for most items",
    partners: ["FedEx", "UPS", "DHL"],
    returnPolicy: "30-day returns for most items"
  },
  certifications: ["ISO 9001:2015", "AS9120B", "ITAR Registered"],
  rating: {
    average: 4.7,
    count: 10000
  },
  majorClients: ["Apple", "Google", "Tesla", "NASA"],
  resources: [
    { name: "Product Catalog", url: "https://www.digikey.com/en/resources/online-catalog", type: "link" },
    { name: "Digi-Key Marketplace", url: "https://www.digikey.com/en/resources/marketplace", type: "link" }
  ],
  customFields: [
    { name: "Inventory Size", value: "Over 1 million products" },
    { name: "Loyalty Program", value: "myDigiKey" }
  ],
  tags: ["Electronics", "Components", "Global Distribution", "Same-Day Shipping"],
  enabledSections: ["overview", "products", "certifications", "resources", "tags"],
  visualTemplate: "detailed"
}

export const texasInstrumentsSampleData: ManufacturerData = {
  name: "Texas Instruments",
  slug: "Texas%20Instruments",
  logo: "/factory-icon.svg",  // TODO: change to LucideIcon 
  type: "Semiconductor Manufacturer",
  majorClients: ["Apple", "Google", "Tesla", "NASA"],
  headquarters: "Dallas, Texas, USA",
  foundedYear: 1930,
  regionsServed: ["Global"],
  website: "https://www.ti.com",
  primaryContact: {
    name: "Jane Smith",
    email: "jane.smith@ti.com",
    phone: "+1 (214) 567-8900"
  },
  customerSupport: {
    phone: "+1 (800) 336-5236",
    email: "support@ti.com",
    chat: "https://www.ti.com/support-quality/contact-us.html"
  },
  address: "12500 TI Blvd, Dallas, TX 75243, USA",
  operatingHours: "Monday-Friday, 9am-5pm (CST)",
  productsOffered: [
    "Analog ICs",
    "Embedded Processors",
    "Digital Signal Processors",
    "Power Management ICs",
    "Sensors",
    "Wireless Connectivity Solutions"
  ],
  availability: "Through authorized distributors and direct sales",
  pricing: "Volume pricing available, contact sales for quotes",
  overview: "Texas Instruments is a global semiconductor design and manufacturing company that develops analog ICs and embedded processors.",
  specialization: ["Analog and Embedded Processing", "Power Management", "Wireless Connectivity"],
  innovation: "TI invests heavily in R&D, focusing on automotive and industrial markets, with over 45,000 patents worldwide.",
  productCategories: ["Analog", "Embedded Processing", "Wireless Connectivity"],
  flagshipProducts: [
    {
      name: "C2000™ Real-time MCUs",
      description: "High-performance microcontrollers for real-time control applications",
      image: "/placeholder.svg?height=200&width=200"
    },
    {
      name: "SimpleLink™ MCUs",
      description: "Low-power, wireless MCUs for IoT applications",
      image: "/placeholder.svg?height=200&width=200"
    }
  ],
  technicalCapabilities: [
    "Advanced analog and mixed-signal processing",
    "Low-power embedded processing",
    "Wireless connectivity solutions",
    "Power management expertise"
  ],
  certifications: ["ISO 9001", "ISO 14001", "IATF 16949"],
  patents: [
    "Over 45,000 patents granted worldwide",
    "Pioneering advancements in analog and digital technology"
  ],
  technicalResources: {
    datasheets: [
      { name: "C2000™ MCU Datasheet", url: "https://www.ti.com/lit/ds/symlink/tms320f28335.pdf", type: "pdf" },
      { name: "SimpleLink™ MCU Datasheet", url: "https://www.ti.com/lit/ds/symlink/cc3220s.pdf", type: "pdf" }
    ],
    applicationNotes: [
      { name: "Analog Design Journal", url: "https://www.ti.com/analog-circuit/analog-design-journal.html", type: "link" },
      { name: "Motor Drive and Control Solutions", url: "https://www.ti.com/applications/industrial/motor-drives/overview.html", type: "link" }
    ],
    cadModels: [
      { name: "TI CAD & 3D Models", url: "https://www.ti.com/support-quality/packaging/cad-3d-model-download.html", type: "link" }
    ],
    videos: [
      { name: "TI Training Videos", url: "https://training.ti.com/ti-training-videos", type: "link" }
    ]
  },
  factories: [
    { location: "Dallas, Texas, USA", description: "300mm wafer fab for analog and embedded processing" },
    { location: "Richardson, Texas, USA", description: "300mm wafer fab for advanced analog" }
  ],
  distributors: ["Digi-Key", "Mouser Electronics", "Arrow Electronics", "Avnet"],
  clientIndustries: ["Automotive", "Industrial", "Personal Electronics", "Communications Equipment", "Enterprise Systems"],
  technicalSupport: {
    email: "support@ti.com",
    phone: "+1 (800) 336-5236"
  },
  salesContacts: [
    { region: "North America", email: "na-sales@ti.com", phone: "+1 (800) 336-5236" },
    { region: "Europe", email: "europe-sales@ti.com", phone: "+49 (0) 8161 80-2121" }
  ],
  rating: {
    average: 4.8,
    count: 15000
  },
  resources: [
    { name: "Product Catalog", url: "https://www.ti.com/product-selection-tools.html", type: "link" },
    { name: "Design Resources", url: "https://www.ti.com/design-resources.html", type: "link" }
  ],
  customFields: [
    { name: "University Program", value: "TI University Program for academic collaboration" },
    { name: "Sustainability Initiative", value: "Committed to responsible manufacturing and recycling" }
  ],
  tags: ["Semiconductors", "Analog", "Embedded Processing", "Automotive", "Industrial"],
  enabledSections: ["overview", "products", "certifications", "resources", "globalPresence"],
  visualTemplate: "detailed"
}

export const supplierList = [
  { id: 'digikey', name: 'Digi-Key Electronics', data: digikeySampleData, url: `/supplier/${encodeURIComponent('Digi-Key Electronics')}` },
]

export const manufacturerList = [
  texasInstrumentsSampleData,
]

